import { defineComponent, computed, openBlock, createElementBlock, createElementVNode, toDisplayString, pushScopeId, popScopeId, createBlock, resolveDynamicComponent } from "vue";
const hashCode = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    let character = name.charCodeAt(i);
    hash = (hash << 5) - hash + character;
    hash = hash & hash;
  }
  return Math.abs(hash);
};
const getDigit = (number, ntn) => {
  return Math.floor(number / Math.pow(10, ntn) % 10);
};
const getBoolean = (number, ntn) => {
  return !(getDigit(number, ntn) % 2);
};
const getUnit = (number, range, index) => {
  let value = number % range;
  if (index && getDigit(number, index) % 2 === 0) {
    return -value;
  } else
    return value;
};
const getRandomColor = (number, colors, range) => {
  return colors[number % range];
};
const getContrast = (hexcolor) => {
  if (hexcolor.slice(0, 1) === "#") {
    hexcolor = hexcolor.slice(1);
  }
  var r = parseInt(hexcolor.substring(0, 2), 16);
  var g = parseInt(hexcolor.substring(2, 4), 16);
  var b = parseInt(hexcolor.substring(4, 6), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1e3;
  return yiq >= 128 ? "#000000" : "#FFFFFF";
};
var _export_sfc = (sfc, props) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props) {
    target[key] = val;
  }
  return target;
};
const ELEMENTS$3 = 4;
const SIZE$5 = 80;
function generateColors$4(name, colors) {
  const numFromName = hashCode(name);
  const range = colors && colors.length;
  const elementsProperties = Array.from({ length: ELEMENTS$3 }, (_, i) => ({
    color: getRandomColor(numFromName + i, colors, range),
    translateX: getUnit(numFromName * (i + 1), SIZE$5 / 2 - (i + 17), 1),
    translateY: getUnit(numFromName * (i + 1), SIZE$5 / 2 - (i + 17), 2),
    rotate: getUnit(numFromName * (i + 1), 360),
    isSquare: getBoolean(numFromName, 2)
  }));
  return elementsProperties;
}
const _sfc_main$6 = defineComponent({
  props: {
    colors: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    square: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const properties = computed(() => generateColors$4(props.name, props.colors));
    return { properties, SIZE: SIZE$5 };
  }
});
const _hoisted_1$5 = ["viewBox", "width", "height"];
const _hoisted_2$5 = ["width", "height"];
const _hoisted_3$5 = ["width", "height", "rx"];
const _hoisted_4$5 = { mask: "url(#mask__bauhaus)" };
const _hoisted_5$5 = ["width", "height", "fill"];
const _hoisted_6$5 = ["x", "y", "width", "height", "fill", "transform"];
const _hoisted_7$5 = ["cx", "cy", "fill", "r", "transform"];
const _hoisted_8$5 = ["y1", "x2", "y2", "stroke", "transform"];
function _sfc_render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    viewBox: `0 0 ${_ctx.SIZE} ${_ctx.SIZE}`,
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size
  }, [
    createElementVNode("title", null, toDisplayString(_ctx.name), 1),
    createElementVNode("mask", {
      id: "mask__bauhaus",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: _ctx.SIZE,
      height: _ctx.SIZE
    }, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        rx: !_ctx.square ? _ctx.SIZE * 2 : void 0,
        fill: "#FFFFFF"
      }, null, 8, _hoisted_3$5)
    ], 8, _hoisted_2$5),
    createElementVNode("g", _hoisted_4$5, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        fill: _ctx.properties[0].color
      }, null, 8, _hoisted_5$5),
      createElementVNode("rect", {
        x: (_ctx.SIZE - 60) / 2,
        y: (_ctx.SIZE - 20) / 2,
        width: _ctx.SIZE,
        height: _ctx.properties[1].isSquare ? _ctx.SIZE : _ctx.SIZE / 8,
        fill: _ctx.properties[1].color,
        transform: `translate(${_ctx.properties[1].translateX} ${_ctx.properties[1].translateY}) rotate(${_ctx.properties[1].rotate} ${_ctx.SIZE / 2} ${_ctx.SIZE / 2})`
      }, null, 8, _hoisted_6$5),
      createElementVNode("circle", {
        cx: _ctx.SIZE / 2,
        cy: _ctx.SIZE / 2,
        fill: _ctx.properties[2].color,
        r: _ctx.SIZE / 5,
        transform: `translate(${_ctx.properties[2].translateX} ${_ctx.properties[2].translateY})`
      }, null, 8, _hoisted_7$5),
      createElementVNode("line", {
        x1: 0,
        y1: _ctx.SIZE / 2,
        x2: _ctx.SIZE,
        y2: _ctx.SIZE / 2,
        "stroke-width": 2,
        stroke: _ctx.properties[3].color,
        transform: `translate(${_ctx.properties[3].translateX} ${_ctx.properties[3].translateY}) rotate(${_ctx.properties[3].rotate} ${_ctx.SIZE / 2} ${_ctx.SIZE / 2})`
      }, null, 8, _hoisted_8$5)
    ])
  ], 8, _hoisted_1$5);
}
var AvatarBauhaus = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6]]);
const SIZE$4 = 36;
function generateData(name, colors) {
  const numFromName = hashCode(name);
  const range = colors && colors.length;
  const wrapperColor = getRandomColor(numFromName, colors, range);
  const preTranslateX = getUnit(numFromName, 10, 1);
  const wrapperTranslateX = preTranslateX < 5 ? preTranslateX + SIZE$4 / 9 : preTranslateX;
  const preTranslateY = getUnit(numFromName, 10, 2);
  const wrapperTranslateY = preTranslateY < 5 ? preTranslateY + SIZE$4 / 9 : preTranslateY;
  const data = {
    wrapperColor,
    faceColor: getContrast(wrapperColor),
    backgroundColor: getRandomColor(numFromName + 13, colors, range),
    wrapperTranslateX,
    wrapperTranslateY,
    wrapperRotate: getUnit(numFromName, 360),
    wrapperScale: 1 + getUnit(numFromName, SIZE$4 / 12) / 10,
    isMouthOpen: getBoolean(numFromName, 2),
    isCircle: getBoolean(numFromName, 1),
    eyeSpread: getUnit(numFromName, 5),
    mouthSpread: getUnit(numFromName, 3),
    faceRotate: getUnit(numFromName, 10, 3),
    faceTranslateX: wrapperTranslateX > SIZE$4 / 6 ? wrapperTranslateX / 2 : getUnit(numFromName, 8, 1),
    faceTranslateY: wrapperTranslateY > SIZE$4 / 6 ? wrapperTranslateY / 2 : getUnit(numFromName, 7, 2)
  };
  return data;
}
const _sfc_main$5 = defineComponent({
  props: {
    colors: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    square: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const data = computed(() => generateData(props.name, props.colors));
    return { data, SIZE: SIZE$4 };
  }
});
const _hoisted_1$4 = ["viewBox", "width", "height"];
const _hoisted_2$4 = ["width", "height"];
const _hoisted_3$4 = ["width", "height", "rx"];
const _hoisted_4$4 = { mask: "url(#mask__beam)" };
const _hoisted_5$4 = ["width", "height", "fill"];
const _hoisted_6$4 = ["width", "height", "transform", "fill", "rx"];
const _hoisted_7$4 = ["transform"];
const _hoisted_8$4 = ["d", "stroke"];
const _hoisted_9$3 = ["d", "fill"];
const _hoisted_10$3 = ["x", "width", "fill"];
const _hoisted_11$3 = ["x", "width", "fill"];
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    viewBox: `0 0 ${_ctx.SIZE} ${_ctx.SIZE}`,
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size
  }, [
    createElementVNode("title", null, toDisplayString(_ctx.name), 1),
    createElementVNode("mask", {
      id: "mask__beam",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: _ctx.SIZE,
      height: _ctx.SIZE
    }, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        rx: !_ctx.square ? _ctx.SIZE * 2 : void 0,
        fill: "#FFFFFF"
      }, null, 8, _hoisted_3$4)
    ], 8, _hoisted_2$4),
    createElementVNode("g", _hoisted_4$4, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        fill: _ctx.data.backgroundColor
      }, null, 8, _hoisted_5$4),
      createElementVNode("rect", {
        x: 0,
        y: 0,
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        transform: `translate(${_ctx.data.wrapperTranslateX} ${_ctx.data.wrapperTranslateY}) rotate(${_ctx.data.wrapperRotate} ${_ctx.SIZE / 2} ${_ctx.SIZE / 2}) scale(${_ctx.data.wrapperScale})`,
        fill: _ctx.data.wrapperColor,
        rx: _ctx.data.isCircle ? _ctx.SIZE : _ctx.SIZE / 6
      }, null, 8, _hoisted_6$4),
      createElementVNode("g", {
        transform: `translate(${_ctx.data.faceTranslateX} ${_ctx.data.faceTranslateY}) rotate(${_ctx.data.faceRotate} ${_ctx.SIZE / 2} ${_ctx.SIZE / 2})`
      }, [
        _ctx.data.isMouthOpen ? (openBlock(), createElementBlock("path", {
          key: 0,
          d: `M15 ${19 + _ctx.data.mouthSpread}c2 1
        4 1 6 0`,
          stroke: _ctx.data.faceColor,
          fill: "none",
          "stroke-linecap": "round"
        }, null, 8, _hoisted_8$4)) : (openBlock(), createElementBlock("path", {
          key: 1,
          d: `M13,${19 + _ctx.data.mouthSpread} a1,0.75 0 0,0 10,0`,
          fill: _ctx.data.faceColor
        }, null, 8, _hoisted_9$3)),
        createElementVNode("rect", {
          x: 14 - _ctx.data.eyeSpread,
          y: 14,
          width: 1.5,
          height: 2,
          rx: 1,
          stroke: "none",
          fill: _ctx.data.faceColor
        }, null, 8, _hoisted_10$3),
        createElementVNode("rect", {
          x: 20 + _ctx.data.eyeSpread,
          y: 14,
          width: 1.5,
          height: 2,
          rx: 1,
          stroke: "none",
          fill: _ctx.data.faceColor
        }, null, 8, _hoisted_11$3)
      ], 8, _hoisted_7$4)
    ])
  ], 8, _hoisted_1$4);
}
var AvatarBeam = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5]]);
var AvatarMarble_vue_vue_type_style_index_0_scoped_true_lang = "";
const ELEMENTS$2 = 3;
const SIZE$3 = 80;
function generateColors$3(name, colors) {
  const numFromName = hashCode(name);
  const range = colors && colors.length;
  const elementsProperties = Array.from({ length: ELEMENTS$2 }, (_, i) => ({
    color: getRandomColor(numFromName + i, colors, range),
    translateX: getUnit(numFromName * (i + 1), SIZE$3 / 10, 1),
    translateY: getUnit(numFromName * (i + 1), SIZE$3 / 10, 2),
    scale: 1.2 + getUnit(numFromName * (i + 1), SIZE$3 / 20) / 10,
    rotate: getUnit(numFromName * (i + 1), 360, 1)
  }));
  return elementsProperties;
}
const _sfc_main$4 = defineComponent({
  props: {
    colors: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    square: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const properties = computed(() => generateColors$3(props.name, props.colors));
    return { properties, SIZE: SIZE$3 };
  }
});
const _withScopeId = (n) => (pushScopeId("data-v-640b2972"), n = n(), popScopeId(), n);
const _hoisted_1$3 = ["viewBox", "width", "height"];
const _hoisted_2$3 = ["width", "height"];
const _hoisted_3$3 = ["width", "height", "rx"];
const _hoisted_4$3 = { mask: "url(#mask__marble)" };
const _hoisted_5$3 = ["width", "height", "fill"];
const _hoisted_6$3 = ["fill", "transform"];
const _hoisted_7$3 = ["fill", "transform"];
const _hoisted_8$3 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("defs", null, [
  /* @__PURE__ */ createElementVNode("filter", {
    id: "prefix__filter0_f",
    filterUnits: "userSpaceOnUse",
    "color-interpolation-filters": "sRGB"
  }, [
    /* @__PURE__ */ createElementVNode("feFlood", {
      "flood-opacity": 0,
      result: "BackgroundImageFix"
    }),
    /* @__PURE__ */ createElementVNode("feBlend", {
      in: "SourceGraphic",
      in2: "BackgroundImageFix",
      result: "shape"
    }),
    /* @__PURE__ */ createElementVNode("feGaussianBlur", {
      stdDeviation: 7,
      result: "effect1_foregroundBlur"
    })
  ])
], -1));
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    viewBox: `0 0 ${_ctx.SIZE} ${_ctx.SIZE}`,
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size
  }, [
    createElementVNode("title", null, toDisplayString(_ctx.name), 1),
    createElementVNode("mask", {
      id: "mask__marble",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: _ctx.SIZE,
      height: _ctx.SIZE
    }, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        rx: _ctx.square ? void 0 : _ctx.SIZE * 2,
        fill: "#FFFFFF"
      }, null, 8, _hoisted_3$3)
    ], 8, _hoisted_2$3),
    createElementVNode("g", _hoisted_4$3, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        fill: _ctx.properties[0].color
      }, null, 8, _hoisted_5$3),
      createElementVNode("path", {
        filter: "url(#prefix__filter0_f)",
        d: "M32.414 59.35L50.376 70.5H72.5v-71H33.728L26.5 13.381l19.057 27.08L32.414 59.35z",
        fill: _ctx.properties[1].color,
        transform: `translate(${_ctx.properties[1].translateX} ${_ctx.properties[1].translateY}) rotate(${_ctx.properties[1].rotate} ${_ctx.SIZE / 2} ${_ctx.SIZE / 2}) scale(${_ctx.properties[2].scale})`
      }, null, 8, _hoisted_6$3),
      createElementVNode("path", {
        filter: "url(#prefix__filter0_f)",
        class: "mix-blend-overlay",
        d: "M22.216 24L0 46.75l14.108 38.129L78 86l-3.081-59.276-22.378 4.005 12.972 20.186-23.35 27.395L22.215 24z",
        fill: _ctx.properties[2].color,
        transform: `translate(${_ctx.properties[2].translateX} ${_ctx.properties[2].translateY}) rotate(${_ctx.properties[2].rotate} ${_ctx.SIZE / 2} ${_ctx.SIZE / 2}) scale(${_ctx.properties[2].scale})`
      }, null, 8, _hoisted_7$3)
    ]),
    _hoisted_8$3
  ], 8, _hoisted_1$3);
}
var AvatarMarble = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__scopeId", "data-v-640b2972"]]);
const ELEMENTS$1 = 64;
const SIZE$2 = 80;
function generateColors$2(name, colors) {
  const numFromName = hashCode(name);
  const range = colors && colors.length;
  const colorList = Array.from({ length: ELEMENTS$1 }, (_, i) => getRandomColor(numFromName % i, colors, range));
  return colorList;
}
const _sfc_main$3 = defineComponent({
  props: {
    colors: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    square: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const pixelColors = computed(() => generateColors$2(props.name, props.colors));
    return { pixelColors, SIZE: SIZE$2 };
  }
});
const _hoisted_1$2 = ["viewBox", "width", "height"];
const _hoisted_2$2 = ["width", "height"];
const _hoisted_3$2 = ["width", "height", "rx"];
const _hoisted_4$2 = { mask: "url(#mask__pixel)" };
const _hoisted_5$2 = ["fill"];
const _hoisted_6$2 = ["fill"];
const _hoisted_7$2 = ["fill"];
const _hoisted_8$2 = ["fill"];
const _hoisted_9$2 = ["fill"];
const _hoisted_10$2 = ["fill"];
const _hoisted_11$2 = ["fill"];
const _hoisted_12$2 = ["fill"];
const _hoisted_13$1 = ["fill"];
const _hoisted_14 = ["fill"];
const _hoisted_15 = ["fill"];
const _hoisted_16 = ["fill"];
const _hoisted_17 = ["fill"];
const _hoisted_18 = ["fill"];
const _hoisted_19 = ["fill"];
const _hoisted_20 = ["fill"];
const _hoisted_21 = ["fill"];
const _hoisted_22 = ["fill"];
const _hoisted_23 = ["fill"];
const _hoisted_24 = ["fill"];
const _hoisted_25 = ["fill"];
const _hoisted_26 = ["fill"];
const _hoisted_27 = ["fill"];
const _hoisted_28 = ["fill"];
const _hoisted_29 = ["fill"];
const _hoisted_30 = ["fill"];
const _hoisted_31 = ["fill"];
const _hoisted_32 = ["fill"];
const _hoisted_33 = ["fill"];
const _hoisted_34 = ["fill"];
const _hoisted_35 = ["fill"];
const _hoisted_36 = ["fill"];
const _hoisted_37 = ["fill"];
const _hoisted_38 = ["fill"];
const _hoisted_39 = ["fill"];
const _hoisted_40 = ["fill"];
const _hoisted_41 = ["fill"];
const _hoisted_42 = ["fill"];
const _hoisted_43 = ["fill"];
const _hoisted_44 = ["fill"];
const _hoisted_45 = ["fill"];
const _hoisted_46 = ["fill"];
const _hoisted_47 = ["fill"];
const _hoisted_48 = ["fill"];
const _hoisted_49 = ["fill"];
const _hoisted_50 = ["fill"];
const _hoisted_51 = ["fill"];
const _hoisted_52 = ["fill"];
const _hoisted_53 = ["fill"];
const _hoisted_54 = ["fill"];
const _hoisted_55 = ["fill"];
const _hoisted_56 = ["fill"];
const _hoisted_57 = ["fill"];
const _hoisted_58 = ["fill"];
const _hoisted_59 = ["fill"];
const _hoisted_60 = ["fill"];
const _hoisted_61 = ["fill"];
const _hoisted_62 = ["fill"];
const _hoisted_63 = ["fill"];
const _hoisted_64 = ["fill"];
const _hoisted_65 = ["fill"];
const _hoisted_66 = ["fill"];
const _hoisted_67 = ["fill"];
const _hoisted_68 = ["fill"];
function _sfc_render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    viewBox: `0 0 ${_ctx.SIZE} ${_ctx.SIZE}`,
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size
  }, [
    createElementVNode("title", null, toDisplayString(_ctx.name), 1),
    createElementVNode("mask", {
      id: "mask__pixel",
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: _ctx.SIZE,
      height: _ctx.SIZE
    }, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        rx: !_ctx.square ? _ctx.SIZE * 2 : void 0,
        fill: "#FFFFFF"
      }, null, 8, _hoisted_3$2)
    ], 8, _hoisted_2$2),
    createElementVNode("g", _hoisted_4$2, [
      createElementVNode("rect", {
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[0]
      }, null, 8, _hoisted_5$2),
      createElementVNode("rect", {
        x: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[1]
      }, null, 8, _hoisted_6$2),
      createElementVNode("rect", {
        x: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[2]
      }, null, 8, _hoisted_7$2),
      createElementVNode("rect", {
        x: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[3]
      }, null, 8, _hoisted_8$2),
      createElementVNode("rect", {
        x: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[4]
      }, null, 8, _hoisted_9$2),
      createElementVNode("rect", {
        x: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[5]
      }, null, 8, _hoisted_10$2),
      createElementVNode("rect", {
        x: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[6]
      }, null, 8, _hoisted_11$2),
      createElementVNode("rect", {
        x: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[7]
      }, null, 8, _hoisted_12$2),
      createElementVNode("rect", {
        y: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[8]
      }, null, 8, _hoisted_13$1),
      createElementVNode("rect", {
        y: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[9]
      }, null, 8, _hoisted_14),
      createElementVNode("rect", {
        y: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[10]
      }, null, 8, _hoisted_15),
      createElementVNode("rect", {
        y: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[11]
      }, null, 8, _hoisted_16),
      createElementVNode("rect", {
        y: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[12]
      }, null, 8, _hoisted_17),
      createElementVNode("rect", {
        y: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[13]
      }, null, 8, _hoisted_18),
      createElementVNode("rect", {
        y: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[14]
      }, null, 8, _hoisted_19),
      createElementVNode("rect", {
        x: 20,
        y: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[15]
      }, null, 8, _hoisted_20),
      createElementVNode("rect", {
        x: 20,
        y: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[16]
      }, null, 8, _hoisted_21),
      createElementVNode("rect", {
        x: 20,
        y: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[17]
      }, null, 8, _hoisted_22),
      createElementVNode("rect", {
        x: 20,
        y: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[18]
      }, null, 8, _hoisted_23),
      createElementVNode("rect", {
        x: 20,
        y: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[19]
      }, null, 8, _hoisted_24),
      createElementVNode("rect", {
        x: 20,
        y: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[20]
      }, null, 8, _hoisted_25),
      createElementVNode("rect", {
        x: 20,
        y: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[21]
      }, null, 8, _hoisted_26),
      createElementVNode("rect", {
        x: 40,
        y: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[22]
      }, null, 8, _hoisted_27),
      createElementVNode("rect", {
        x: 40,
        y: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[23]
      }, null, 8, _hoisted_28),
      createElementVNode("rect", {
        x: 40,
        y: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[24]
      }, null, 8, _hoisted_29),
      createElementVNode("rect", {
        x: 40,
        y: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[25]
      }, null, 8, _hoisted_30),
      createElementVNode("rect", {
        x: 40,
        y: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[26]
      }, null, 8, _hoisted_31),
      createElementVNode("rect", {
        x: 40,
        y: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[27]
      }, null, 8, _hoisted_32),
      createElementVNode("rect", {
        x: 40,
        y: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[28]
      }, null, 8, _hoisted_33),
      createElementVNode("rect", {
        x: 60,
        y: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[29]
      }, null, 8, _hoisted_34),
      createElementVNode("rect", {
        x: 60,
        y: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[30]
      }, null, 8, _hoisted_35),
      createElementVNode("rect", {
        x: 60,
        y: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[31]
      }, null, 8, _hoisted_36),
      createElementVNode("rect", {
        x: 60,
        y: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[32]
      }, null, 8, _hoisted_37),
      createElementVNode("rect", {
        x: 60,
        y: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[33]
      }, null, 8, _hoisted_38),
      createElementVNode("rect", {
        x: 60,
        y: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[34]
      }, null, 8, _hoisted_39),
      createElementVNode("rect", {
        x: 60,
        y: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[35]
      }, null, 8, _hoisted_40),
      createElementVNode("rect", {
        x: 10,
        y: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[36]
      }, null, 8, _hoisted_41),
      createElementVNode("rect", {
        x: 10,
        y: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[37]
      }, null, 8, _hoisted_42),
      createElementVNode("rect", {
        x: 10,
        y: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[38]
      }, null, 8, _hoisted_43),
      createElementVNode("rect", {
        x: 10,
        y: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[39]
      }, null, 8, _hoisted_44),
      createElementVNode("rect", {
        x: 10,
        y: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[40]
      }, null, 8, _hoisted_45),
      createElementVNode("rect", {
        x: 10,
        y: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[41]
      }, null, 8, _hoisted_46),
      createElementVNode("rect", {
        x: 10,
        y: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[42]
      }, null, 8, _hoisted_47),
      createElementVNode("rect", {
        x: 30,
        y: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[43]
      }, null, 8, _hoisted_48),
      createElementVNode("rect", {
        x: 30,
        y: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[44]
      }, null, 8, _hoisted_49),
      createElementVNode("rect", {
        x: 30,
        y: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[45]
      }, null, 8, _hoisted_50),
      createElementVNode("rect", {
        x: 30,
        y: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[46]
      }, null, 8, _hoisted_51),
      createElementVNode("rect", {
        x: 30,
        y: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[47]
      }, null, 8, _hoisted_52),
      createElementVNode("rect", {
        x: 30,
        y: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[48]
      }, null, 8, _hoisted_53),
      createElementVNode("rect", {
        x: 30,
        y: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[49]
      }, null, 8, _hoisted_54),
      createElementVNode("rect", {
        x: 50,
        y: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[50]
      }, null, 8, _hoisted_55),
      createElementVNode("rect", {
        x: 50,
        y: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[51]
      }, null, 8, _hoisted_56),
      createElementVNode("rect", {
        x: 50,
        y: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[52]
      }, null, 8, _hoisted_57),
      createElementVNode("rect", {
        x: 50,
        y: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[53]
      }, null, 8, _hoisted_58),
      createElementVNode("rect", {
        x: 50,
        y: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[54]
      }, null, 8, _hoisted_59),
      createElementVNode("rect", {
        x: 50,
        y: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[55]
      }, null, 8, _hoisted_60),
      createElementVNode("rect", {
        x: 50,
        y: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[56]
      }, null, 8, _hoisted_61),
      createElementVNode("rect", {
        x: 70,
        y: 10,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[57]
      }, null, 8, _hoisted_62),
      createElementVNode("rect", {
        x: 70,
        y: 20,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[58]
      }, null, 8, _hoisted_63),
      createElementVNode("rect", {
        x: 70,
        y: 30,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[59]
      }, null, 8, _hoisted_64),
      createElementVNode("rect", {
        x: 70,
        y: 40,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[60]
      }, null, 8, _hoisted_65),
      createElementVNode("rect", {
        x: 70,
        y: 50,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[61]
      }, null, 8, _hoisted_66),
      createElementVNode("rect", {
        x: 70,
        y: 60,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[62]
      }, null, 8, _hoisted_67),
      createElementVNode("rect", {
        x: 70,
        y: 70,
        width: 10,
        height: 10,
        fill: _ctx.pixelColors[63]
      }, null, 8, _hoisted_68)
    ])
  ], 8, _hoisted_1$2);
}
var AvatarPixel = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3]]);
const SIZE$1 = 90;
const COLORS = 5;
function generateColors$1(name, colors) {
  const numFromName = hashCode(name);
  const range = colors && colors.length;
  const colorsShuffle = Array.from({ length: COLORS }, (_, i) => getRandomColor(numFromName + i, colors, range));
  const colorsList = [];
  colorsList[0] = colorsShuffle[0];
  colorsList[1] = colorsShuffle[1];
  colorsList[2] = colorsShuffle[1];
  colorsList[3] = colorsShuffle[2];
  colorsList[4] = colorsShuffle[2];
  colorsList[5] = colorsShuffle[3];
  colorsList[6] = colorsShuffle[3];
  colorsList[7] = colorsShuffle[0];
  colorsList[8] = colorsShuffle[4];
  return colorsList;
}
const _sfc_main$2 = defineComponent({
  props: {
    colors: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    square: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const ringColors = computed(() => generateColors$1(props.name, props.colors));
    return { ringColors, SIZE: SIZE$1 };
  }
});
const _hoisted_1$1 = ["viewBox", "width", "height"];
const _hoisted_2$1 = ["width", "height"];
const _hoisted_3$1 = ["width", "height", "rx"];
const _hoisted_4$1 = { mask: "url(#mask__ring)" };
const _hoisted_5$1 = ["fill"];
const _hoisted_6$1 = ["fill"];
const _hoisted_7$1 = ["fill"];
const _hoisted_8$1 = ["fill"];
const _hoisted_9$1 = ["fill"];
const _hoisted_10$1 = ["fill"];
const _hoisted_11$1 = ["fill"];
const _hoisted_12$1 = ["fill"];
const _hoisted_13 = ["fill"];
function _sfc_render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    viewBox: `0 0 ${_ctx.SIZE} ${_ctx.SIZE}`,
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size
  }, [
    createElementVNode("title", null, toDisplayString(_ctx.name), 1),
    createElementVNode("mask", {
      id: "mask__ring",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: _ctx.SIZE,
      height: _ctx.SIZE
    }, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        rx: !_ctx.square ? _ctx.SIZE * 2 : void 0,
        fill: "#FFFFFF"
      }, null, 8, _hoisted_3$1)
    ], 8, _hoisted_2$1),
    createElementVNode("g", _hoisted_4$1, [
      createElementVNode("path", {
        d: "M0 0h90v45H0z",
        fill: _ctx.ringColors[0]
      }, null, 8, _hoisted_5$1),
      createElementVNode("path", {
        d: "M0 45h90v45H0z",
        fill: _ctx.ringColors[1]
      }, null, 8, _hoisted_6$1),
      createElementVNode("path", {
        d: "M83 45a38 38 0 00-76 0h76z",
        fill: _ctx.ringColors[2]
      }, null, 8, _hoisted_7$1),
      createElementVNode("path", {
        d: "M83 45a38 38 0 01-76 0h76z",
        fill: _ctx.ringColors[3]
      }, null, 8, _hoisted_8$1),
      createElementVNode("path", {
        d: "M77 45a32 32 0 10-64 0h64z",
        fill: _ctx.ringColors[4]
      }, null, 8, _hoisted_9$1),
      createElementVNode("path", {
        d: "M77 45a32 32 0 11-64 0h64z",
        fill: _ctx.ringColors[5]
      }, null, 8, _hoisted_10$1),
      createElementVNode("path", {
        d: "M71 45a26 26 0 00-52 0h52z",
        fill: _ctx.ringColors[6]
      }, null, 8, _hoisted_11$1),
      createElementVNode("path", {
        d: "M71 45a26 26 0 01-52 0h52z",
        fill: _ctx.ringColors[7]
      }, null, 8, _hoisted_12$1),
      createElementVNode("circle", {
        cx: 45,
        cy: 45,
        r: 23,
        fill: _ctx.ringColors[8]
      }, null, 8, _hoisted_13)
    ])
  ], 8, _hoisted_1$1);
}
var AvatarRing = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2]]);
const ELEMENTS = 4;
const SIZE = 80;
function generateColors(name, colors) {
  const numFromName = hashCode(name);
  const range = colors && colors.length;
  const colorsList = Array.from({ length: ELEMENTS }, (_, i) => getRandomColor(numFromName + i, colors, range));
  return colorsList;
}
const _sfc_main$1 = defineComponent({
  props: {
    colors: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    square: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const sunsetColors = computed(() => generateColors(props.name, props.colors));
    const name = computed(() => props.name.replace(/\s/g, ""));
    const propsName = props.name;
    return { sunsetColors, propsName, name, SIZE };
  }
});
const _hoisted_1 = ["viewBox", "width", "height"];
const _hoisted_2 = ["width", "height"];
const _hoisted_3 = ["width", "height", "rx"];
const _hoisted_4 = { mask: "url(#mask__sunset)" };
const _hoisted_5 = ["fill"];
const _hoisted_6 = ["fill"];
const _hoisted_7 = ["id", "x1", "x2", "y2"];
const _hoisted_8 = ["stop-color"];
const _hoisted_9 = ["stop-color"];
const _hoisted_10 = ["id", "x1", "y1", "x2", "y2"];
const _hoisted_11 = ["stop-color"];
const _hoisted_12 = ["stop-color"];
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    viewBox: `0 0 ${_ctx.SIZE} ${_ctx.SIZE}`,
    fill: "none",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size
  }, [
    createElementVNode("title", null, toDisplayString(_ctx.propsName), 1),
    createElementVNode("mask", {
      id: "mask__sunset",
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: _ctx.SIZE,
      height: _ctx.SIZE
    }, [
      createElementVNode("rect", {
        width: _ctx.SIZE,
        height: _ctx.SIZE,
        rx: !_ctx.square ? _ctx.SIZE * 2 : void 0,
        fill: "#FFFFFF"
      }, null, 8, _hoisted_3)
    ], 8, _hoisted_2),
    createElementVNode("g", _hoisted_4, [
      createElementVNode("path", {
        fill: `url(#gradient_paint0_linear_${_ctx.name})`,
        d: "M0 0h80v40H0z"
      }, null, 8, _hoisted_5),
      createElementVNode("path", {
        fill: `url(#gradient_paint1_linear_${_ctx.name})`,
        d: "M0 40h80v40H0z"
      }, null, 8, _hoisted_6)
    ]),
    createElementVNode("defs", null, [
      createElementVNode("linearGradient", {
        id: `gradient_paint0_linear_${_ctx.name}`,
        x1: _ctx.SIZE / 2,
        y1: 0,
        x2: _ctx.SIZE / 2,
        y2: _ctx.SIZE / 2,
        gradientUnits: "userSpaceOnUse"
      }, [
        createElementVNode("stop", {
          "stop-color": _ctx.sunsetColors[0]
        }, null, 8, _hoisted_8),
        createElementVNode("stop", {
          offset: 1,
          "stop-color": _ctx.sunsetColors[1]
        }, null, 8, _hoisted_9)
      ], 8, _hoisted_7),
      createElementVNode("linearGradient", {
        id: `gradient_paint1_linear_${_ctx.name}`,
        x1: _ctx.SIZE / 2,
        y1: _ctx.SIZE / 2,
        x2: _ctx.SIZE / 2,
        y2: _ctx.SIZE,
        gradientUnits: "userSpaceOnUse"
      }, [
        createElementVNode("stop", {
          "stop-color": _ctx.sunsetColors[2]
        }, null, 8, _hoisted_11),
        createElementVNode("stop", {
          offset: 1,
          "stop-color": _ctx.sunsetColors[3]
        }, null, 8, _hoisted_12)
      ], 8, _hoisted_10)
    ])
  ], 8, _hoisted_1);
}
var AvatarSunset = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1]]);
const _sfc_main = defineComponent({
  name: "Avatar",
  props: {
    variant: {
      type: String,
      required: false,
      default: "marble",
      validator(value) {
        return [
          "bauhaus",
          "beam",
          "marble",
          "pixel",
          "ring",
          "sunset"
        ].includes(value);
      }
    },
    colors: {
      type: Array,
      required: false,
      default: ["#92A1C6", "#146A7C", "#F0AB3D", "#C271B4", "#C20D90"]
    },
    name: {
      type: String,
      required: false,
      default: "Clara Barton"
    },
    square: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: Number,
      required: false,
      default: 40
    }
  },
  setup() {
    return {};
  },
  components: {
    AvatarBauhaus,
    AvatarBeam,
    AvatarMarble,
    AvatarPixel,
    AvatarRing,
    AvatarSunset
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent(`avatar-${_ctx.variant}`), {
    colors: _ctx.colors,
    name: _ctx.name,
    square: _ctx.square,
    size: _ctx.size
  }, null, 8, ["colors", "name", "square", "size"]);
}
var Avatar = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { Avatar as default };
